const inputHasValue = () => {
    $('input, textarea').focus(function () {
        $(this).parent().addClass('input-has-value');
    }).blur(function () {
        if (!$(this).val()) {
            $(this).parent().removeClass('input-has-value');
        }
    });
};

const loginFunction = () => {
    $('.login-page__form#login').on('submit', function (e) {
        e.preventDefault();
        $('.login-page__form .status').show().text(settings.loadingmessage);

        const ajaxData = {
            action: 'ajax_login',
            username: $('.login-page__form #email').val(),
            password: $('.login-page__form #password').val()
        };
        $.post(settings.ajax_url, ajaxData)
            .done((response) =>{
                response = JSON.parse(response);
                $('.login-page__form .status').text(response.message);
                if (response.loggedin == true) {
                    document.location.href = settings.redirecturl;
                }
            });
    });
};

const createAccount = () => {
    $('.login-page__form#register').on('submit', function (e) {
        e.preventDefault();

        const ajaxData = {
            action: 'ajax_register',
            username: $('.login-page__form #email').val(),
            password: $('.login-page__form #password').val()
        };
        $.post(settings.ajax_url, ajaxData)
            .done((response) =>{
                // response = JSON.parse(response);
                $('.login-page__form .status').text(response).show();
            });
    });
};

function validateRegisterForm(){
    let firstName = $('#billing_first_name'),
        lastName = $('#billing_last_name'),
        email = $('#reg_email'),
        password = $('#password');

        let error = false;
        if (!firstName.val()) {
            firstName.parent().next('.error').show();
            error = true;
        } else {
            firstName.parent().next('.error').hide();
        }
        if (!lastName.val()) {
            lastName.parent().next('.error').show();
            error = true;
        } else {
            lastName.parent().next('.error').hide();
        }
        if (!email.val()) {
            email.parent().next('.error').show();
            error = true;
        } else {
            email.parent().next('.error').hide();
        }
        if (!password.val()) {
            password.parent().next('.error').show();
            error = true;
        } else {
            password.parent().next('.error').hide();
        }
        if (password.val().length < 6) {
            password.parent().next('.error').next('.error').show();
            error = true;
        } else {
            password.parent().next('.error').next('.error').hide();
        }

        if(!error) {
            $('.woocommerce-form-row .error').hide();
            return true;
        }

        return !error;
}

export {inputHasValue, loginFunction, createAccount, validateRegisterForm};



// WEBPACK FOOTER //
// ./src/scripts/form.js